export default __webpack_public_path__ + "static/media/sales.43f5faba.svg";